import { render, staticRenderFns } from "./PermanenceChart.vue?vue&type=template&id=687d1221"
import script from "./PermanenceChart.vue?vue&type=script&lang=js"
export * from "./PermanenceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports